import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  .banner-block {
    position: relative;
    overflow: hidden;
    z-index: 2;
    .banner-image-desktop {
      width: 100%;
      height: 100%;
      aspect-ratio: 1441 / 632;
      object-fit: cover;
    }
    .container {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      .banner-title-block {
        font-size: 36px;
        font-weight: normal;
        line-height: 60px;
        margin: 0;
        color: ${theme.white};
        text-align: center;
        p {
          margin: 0px;
          padding: 0px;
          a {
            font-family: 'Kanit-SemiBold';
            color: ${theme.red};
            pointer-events: none;
          }
        }
        strong {
          font-weight: normal;
          letter-spacing: normal;
          font-family: 'Kanit-SemiBold';
        }
      }
      .banner-button-block {
        margin-top: 40px;
        button {
          box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
          span {
            font-family: 'Kanit-SemiBold';
            font-size: 32px;
          }
        }
      }
    }
  }

  @media (max-width: ${breakpoint.lg}) {
    .banner-block .banner-title-block .banner-button-block {
      margin-top: 10px;
    }
  }
  @media (max-width: ${breakpoint.md}) {
    .banner-block {
      border-radius: 0;
      .banner-image-desktop {
        object-fit: cover;
        aspect-ratio: 360 / 245;
        width: 100%;
        height: 100%;
      }
      .container {
        .banner-title-block {
          font-size: 24px;
          line-height: 1.5;
        }
        .banner-button-block {
          button {
            span {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
`
